module.exports = __webpack_public_path__ + "img/contact_image.372a6d97.png";